import { getRequest } from '../../services.js/apiService';

const STAFF_API_URL = `${process.env.REACT_APP_API_URL}/staff`;

export const getReceiptUploadsByParams = (params) => async () => getRequest(`${STAFF_API_URL}/receiptUploads/search`, params);
